import { cleartaxAxios } from '../../../http-common';

class IFSCDataService {
  create(text: string, token: string | null) {
    const data = {
      requests: [
        {
          indexName: 'IFSC_UPDATED',
          params: `query=${text}&hitsPerPage=5&page=0`,
        },
      ],
    };
    return cleartaxAxios.post(
      '/f/content_search/algolia/algolia-search/?captcha_token=' + token,
      data
    );
  }
  getBankIndividuals(bank_name: string | string[]) {
    return cleartaxAxios.get(
      `/f/ifsc-code-api/branch/get-bank-details/${bank_name}/`
    );
  }
  getIFSCDetails(ifsc_code: string | string[]) {
    return cleartaxAxios.get(`/f/ifsc-code-api/branch/${ifsc_code}/`);
  }
  getAllBankDetails() {
    return cleartaxAxios.get(`/f/ifsc-code-api/crud/`);
  }

  getTopFund() {
    const data = {
      requests: [
        {
          indexName: 'clearsave_all_funds',
          params: `query=${''}&hitsPerPage=3&page=0`,
        },
      ],
    };
    return cleartaxAxios.post(
      '/f/content_search/algolia/algolia-search/',
      data
    );
  }
}
export default new IFSCDataService();
